(function(){
  // ----- helpers -----
  const root = document.querySelector('variant-selects, form[data-type="add-to-cart-form"]') || document;
  const q  = (sel, r=root) => r.querySelector(sel);
  const qa = (sel, r=root) => Array.from(r.querySelectorAll(sel));

  const F_HANDLES = ['ausrichtung','formate','orientation'];
  const S_HANDLES = ['größe','groesse','size'];

  function findFs(handles, legendRE){
    for (const h of handles){
      const fs = q(`fieldset[data-handle="${h}"]`);
      if (fs) return fs;
    }
    return qa('fieldset').find(fs=>{
      const lg = q('legend', fs);
      return lg && legendRE.test((lg.textContent||'').toLowerCase());
    }) || null;
  }

  function sizeSelects(){
    const fs = findFs(S_HANDLES, /größe|groe|size/);
    return fs ? qa('select', fs) : [];
  }
  function isValid(sel){
    const cur = sel.selectedOptions && sel.selectedOptions[0];
    return !!(cur && !cur.disabled && cur.value !== '');
  }
  function firstEnabled(sel){
    return Array.from(sel.options||[]).find(o => o.value !== '' && !o.disabled) || null;
  }
  function selectFirstEnabled(sel){
    if (!sel) return false;
    const first = firstEnabled(sel);
    if (!first) return false;
    if (sel.value === first.value && isValid(sel)) return true;
    sel.value = first.value;
    sel.dispatchEvent(new Event('input',  { bubbles:true }));
    sel.dispatchEvent(new Event('change', { bubbles:true }));
    return true;
  }

  // ----- Guard-Fenster nach Ausrichtungswechsel -----
  let guardUntil = 0;
  function inGuard(){ return performance.now() < guardUntil; }
  function startGuard(ms=1400){
    guardUntil = performance.now() + ms;
    kickLoop();           // sofort anstoßen
  }

  // wiederholt versuchen, solange Guard aktiv ist
  let loopRunning = false;
  function kickLoop(){
    if (loopRunning) return;
    loopRunning = true;
    (function tick(){
      const stillGuard = inGuard();
      if (stillGuard){
        sizeSelects().forEach(selectFirstEnabled);
        requestAnimationFrame(tick);
      } else {
        loopRunning = false;
      }
    })();
  }

  // Delegiert auf Format-Select/Radio (überlebt Re-Render)
  document.addEventListener('change', (e)=>{
    const fs = e.target.closest('fieldset');
    if (!fs) return;
    const handle = (fs.getAttribute('data-handle')||'').toLowerCase();
    const legend = (q('legend', fs)?.textContent||'').toLowerCase();
    if (F_HANDLES.includes(handle) || /ausrichtung|format/.test(legend)){
      startGuard(1600); // kurz streng sein, dann den User lassen
    }
  }, true);

  // Mutationen am Größen-Feld -> während Guard erneut versuchen
  const fsSize = findFs(S_HANDLES, /größe|groe|size/);
  if (fsSize){
    new MutationObserver(()=>{ if (inGuard()) kickLoop(); })
      .observe(fsSize, { childList:true, subtree:true, attributes:true, attributeFilter:['disabled','class','aria-disabled'] });
  }

  // Falls PDP initial in „ungültigem“ Zustand landet
  startGuard(600);
})();